import { createAction } from 'store/utils';
import {
  CLEAR_TIFD_REPORT,
  FILL_TIFD_WORKBOOK_FAILURE,
  FILL_TIFD_WORKBOOK_REQUEST,
  FILL_TIFD_WORKBOOK_SUCCESS,
  GET_TIFD_REPORT_FAILURE,
  GET_TIFD_REPORT_REQUEST,
  PREVIEW_TIFD_REPORT_FAILURE,
  PREVIEW_TIFD_REPORT_REQUEST,
  PREVIEW_TIFD_REPORT_SUCCESS,
} from './constants';
import { TifdReport, TifdReportContext } from './models';
import {
  ClearTifdReportAction,
  FillTifdWorkbookFailureAction,
  FillTifdWorkbookRequestAction,
  FillTifdWorkbookRequestActionPayload,
  FillTifdWorkbookSuccessAction,
  GetTifdReportFailureAction,
  GetTifdReportRequestAction,
  GetTifdReportRequestActionPayload,
  PreviewTifdReportFailureAction,
  PreviewTifdReportRequestAction,
  PreviewTifdReportRequestActionPayload,
  PreviewTifdReportSuccessAction,
} from './types';

export const previewTifdReportRequest = (
  payload: PreviewTifdReportRequestActionPayload
): PreviewTifdReportRequestAction =>
  createAction(PREVIEW_TIFD_REPORT_REQUEST, payload);

export const previewTifdReportSuccess = (
  report: TifdReport,
  context: TifdReportContext
): PreviewTifdReportSuccessAction =>
  createAction(PREVIEW_TIFD_REPORT_SUCCESS, { report, context });

export const previewTifdReportFailure = (): PreviewTifdReportFailureAction =>
  createAction(PREVIEW_TIFD_REPORT_FAILURE);

export const fillTifdWorkbookRequest = (
  payload: FillTifdWorkbookRequestActionPayload
): FillTifdWorkbookRequestAction =>
  createAction(FILL_TIFD_WORKBOOK_REQUEST, payload);

export const fillTifdWorkbookSuccess = (): FillTifdWorkbookSuccessAction =>
  createAction(FILL_TIFD_WORKBOOK_SUCCESS);

export const fillTifdWorkbookFailure = (): FillTifdWorkbookFailureAction =>
  createAction(FILL_TIFD_WORKBOOK_FAILURE);

export const loadTifdReportRequest = (
  payload: GetTifdReportRequestActionPayload
): GetTifdReportRequestAction =>
  createAction(GET_TIFD_REPORT_REQUEST, payload);

export const loadTifdReportFailure = (): GetTifdReportFailureAction =>
  createAction(GET_TIFD_REPORT_FAILURE);

export const clearTifdReport = (): ClearTifdReportAction =>
  createAction(CLEAR_TIFD_REPORT);
